import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
  OTHER_TUITION,
} from '../ChildrenInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import InputDollar from '../../InputDollar/InputDollarView';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { schoolTuition } from '../ChildrenInfoWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

const SchoolTuition = ({
  workflowId,
  branch,
  clientId,
  store,
  schoolTuitionAmount,
  isEditingGoal,
  educationGoal,
  onPostProcess,
  selectedEducationType,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={educationGoal.IsSpecificCollege || selectedEducationType !== OTHER_TUITION}
    id="ChildAge"
  >
    <Validation workflowId={workflowId} validationId={`${BACKEND_EDUCATION_LIST_KEY}.Amount`} />
    <h2>What is the expected annual tuition?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            placeholder="School Tuition"
            id="adv-school-tuition"
            isUnder
            className="sm text-center"
            value={schoolTuitionAmount}
            onChange={event => {
              const saveAnnualTuition = inputTextChanged(
                clientId,
                store(workflowId),
                `${BACKEND_EDUCATION_LIST_KEY}.Amount`,
              );
              saveAnnualTuition(event);
            }}
          />
        </li>
      </ul>
    </AdvForm>
    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={schoolTuition(schoolTuitionAmount)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.Amount`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      doNotSave={!isEditingGoal}
      onPostProcess={data => onPostProcess(data, educationGoal)}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'school_tuition_completed')}
    />
  </AdvWorkflowStep>
);

SchoolTuition.defaultProps = {
  schoolTuitionAmount: 0,
};

SchoolTuition.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  schoolTuitionAmount: PropTypes.number,
  store: PropTypes.func.isRequired,
  selectedEducationType: PropTypes.number.isRequired,
  isEditingGoal: PropTypes.bool.isRequired,
  educationGoal: PropTypes.shape({
    Amount: PropTypes.string,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
};

export default SchoolTuition;
